import { FC } from 'react';

import { FormLabel } from '@chakra-ui/react';

import { RadioGroup } from '../../../shared/RadioGroup';

import { DealMediaEdit } from '../../../../types/media';
import { ACCEPT_MIME_STRING } from '../../../../utils/fileValidation';
import { getDealMediaFromAcceptedFiles } from '../../../../utils/media';
import Dropzone from '../../../Dropzone';

interface UploadPayoffDocsRadioAndDropzoneProps {
  selectedMedia: DealMediaEdit[];
  setSelectedMedia: (selectedMedia: DealMediaEdit[]) => void;
  needsPayoffDocuments: boolean;
  setNeedsPayoffDocuments: (needsPayoffDocuments: boolean) => void;
  setPayoffDocumentsUploaded: (payoffDocumentsUploaded: boolean) => void;
  inConfirmModal?: boolean;
  dropzoneMarginTop?: number;
}

const UploadPayoffDocsRadioAndDropzone: FC<UploadPayoffDocsRadioAndDropzoneProps> = ({
  selectedMedia,
  setSelectedMedia,
  needsPayoffDocuments,
  setNeedsPayoffDocuments,
  setPayoffDocumentsUploaded,
  inConfirmModal = false,
  dropzoneMarginTop = 0,
}) => {
  const handleDrop = async (acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      return;
    }
    const media = await getDealMediaFromAcceptedFiles(acceptedFiles);
    setSelectedMedia(media);
    setPayoffDocumentsUploaded(true);
  };

  const handleRadioChange = (e: string) => {
    setNeedsPayoffDocuments(e === 'true');

    if (e === 'false') {
      setSelectedMedia([]);
      setPayoffDocumentsUploaded(false);
    }
  };

  return (
    <>
      <FormLabel>Do you need to upload a payoff doc?</FormLabel>
      <RadioGroup onChange={handleRadioChange} value={needsPayoffDocuments} />
      {needsPayoffDocuments ? (
        <>
          <Dropzone
            onDrop={handleDrop}
            accept={ACCEPT_MIME_STRING}
            showFiles
            acceptedFiles={selectedMedia.map((m) => m.selectedFile as File)}
            multiple
            marginTop={dropzoneMarginTop}
          />
          {inConfirmModal ? (
            <FormLabel alignSelf="center">
              (Documents can also be uploaded after confirming)
            </FormLabel>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default UploadPayoffDocsRadioAndDropzone;
